import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import {useTranslation} from "react-i18next";
import "../../css/main.css";
import "../../css/components/Modals/DeleteWarning.css";

export default function DeleteResourceModal({ openResourceDeleteModal, handleCloseResourceDeleteModal, handleDeleteResource, avoidMisfire}) {
    const { t } = useTranslation();
    
    return (
        <Dialog open={openResourceDeleteModal} onClose={handleCloseResourceDeleteModal} className="modal-background-color">
            <DialogTitle>{t("modal.warning")}</DialogTitle>
            <DialogContent className="white-txt-color">
                {t("modal.resource_delete")}
            </DialogContent>
            <DialogContent className="delete-resource-dialog-content">
            <WarningIcon className="delete-resource-warning-margin-right" color="warning"/> {t("modal.irreversible")} <WarningIcon className="delete-resource-warning-margin-left" color="warning"/>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseResourceDeleteModal} className="button-dark-bg">
                    {t("global.cancel")}
                </Button>
                <Button onClick={handleDeleteResource} disabled={avoidMisfire} className="button-dark-bg">
                    {t("modal.delete")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}